import {
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Switch,
  InputAdornment,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Dialog from "../../dialog";
import Snackbar from "../../snackbar";
import CountryCode from "../../countryCode";
import { editStyle } from "./styles";
import SelectedBranch from "../../selectedBranch";
import Loading from "../../loading";
import InputFileReader from "../../fileReader";
import NumberFormatCustom from "../../numberFormat";
import { _pick } from "../../../utils/setting";
import InputFormat from "../../../partials/inputForm";
import { getNumberOnString } from "../../../partials/validateNumber";
class EditInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editEmployee: {
        ...this.props.data,
        bonus:
          this.props.data.typeBonus == "percent"
            ? this.props.data.bonus * 100
            : this.props.data.bonus,
      },
      dialog: {
        messageConfirm: "",
        content: "",
      },
      branch: this.props.data.branchCodes || [],
    };
    this.typeEmployee = ["operator", "executor"];
    this.listTypeBonus = ["percent", "value"];
    this.listTypeSalary = [
      { name: "month", value: "month" },
      { name: "date", value: "date" },
      { name: "hour", value: "hour" },
    ];
    this.handleCheckAvatar = this.handleCheckAvatar.bind(this);
  }
  componentDidMount() {}
  handleInputChange = (name, value) => {
    var editEmployee = this.state.editEmployee;
    if (name === "employeeNumber" || name === "salary" || name === "bonus") {
      value = getNumberOnString(value);
    }
    editEmployee[name] = value;
    this.setState({ editEmployee });
  };
  async handleDeleteEmployee() {
    let { t, history } = this.props;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let dataDelete = JSON.stringify({
      mobile: this.state.editEmployee.mobile,
      countryCode: this.state.editEmployee.countryCode,
    });
    let data = [dataDelete];
    let check = await this.props.employeeDispatch.deleteEmployeeService({
      mobileArr: data,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("employees_listemployee_delete_successfully")
      );
      this.props.afterFetch();
    } else {
      this.mSnackbar.handleClick(
        t("employees_listemployee_delete_delete_unsuccessfully") +
          " " +
          check.message,
        "error"
      );
    }
  }
  handleChangeSwitchBar = (name, value) => {
    var editEmployee = this.state.editEmployee;
    editEmployee[name] = value === true ? 1 : 0;
    this.setState({ editEmployee });
  };
  handleOpenDialog = (typeConfirm) => {
    let { t } = this.props;
    if (typeConfirm === "update") {
      let { editEmployee = {} } = this.state;
      editEmployee.bonus = Number(editEmployee.bonus);
      if (editEmployee.typeBonus == "percent") editEmployee.bonus /= 100;
      if (!editEmployee.name)
        this.mSnackbar.handleClick(
          t("employees_listemployee_editemployee_editcontent_fill_in_name"),
          "warning"
        );
      else if (editEmployee.typeBonus === "percent" && editEmployee.bonus > 1)
        this.mSnackbar.handleClick(
          t(
            "employees_listemployee_editemployee_please_enter_discount_less_than_or_equal_to_100_for_percent"
          ),
          "warning"
        );
      else {
        this.handleCheckAvatar();
      }
    } else {
      this.setState(
        {
          dialog: {
            messageConfirm:
              "employees_listemployee_editemployee_editcontent_fired",
            content:
              "employees_listemployee_editemployee_editcontent_are_you_sure_that_you_want_to_fired_employee_out_of_system",
          },
        },
        function () {
          this.mDialog.handleDialogOpen();
        }
      );
    }
  };
  actionDialog = () => {
    let { t } = this.props;
    if (
      this.state.dialog.messageConfirm ===
      "employees_listemployee_editemployee_editcontent_fired"
    ) {
      this.handleDeleteEmployee();
    } else if (
      this.state.dialog.messageConfirm ===
      "employees_listemployee_editemployee_editcontent_update"
    ) {
      this.handleCheckAvatar();
    }
  };
  async handleCheckAvatar() {
    let { t } = this.props;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let editEmployee = this.state.editEmployee;
    editEmployee.arrBranch = JSON.stringify(
      this.arrHaveBranchName(this.state.branch)
    );
    let files = this.InputFileReader.getFile();
    let src = this.InputFileReader.getSrc();
    if (files !== null) {
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: files,
        code: this.props.serviceCode,
        imgPre: editEmployee.avatarImage,
        type: "avatar-employee",
      });
      if (checkUpload.code === 1) {
        editEmployee.avatarImage = checkUpload.data.previewLink;
      }
      this.handleEditEmployee(editEmployee);
    } else if (src !== null) {
      editEmployee.avatarImage = src;
      this.handleEditEmployee(editEmployee);
    } else if (files === null && src === null) {
      if (editEmployee.avatarImage && this.InputFileReader.getFlagEdit()) {
        // đang có hình ảnh trong database và đã thay đổi file upload hình ảnh
        editEmployee.avatarImage = "";
      }
      this.handleEditEmployee(editEmployee);
    }
  }
  handleEditEmployee = async (data) => {
    let { t } = this.props;
    let check = await this.props.employeeDispatch.updateEmployeeService({
      employee: data,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("employees_listemployee_editemployee_editcontent_update_successfully")
      );
      this.props.afterFetch();
    } else if (!check.code) {
      this.mSnackbar.handleClick(
        t(
          "employees_listemployee_editemployee_editcontent_update_unsuccessfully"
        ) +
          " " +
          check.message,
        "error"
      );
    }
  };
  getFormattedDate = (date) => {
    return moment(date).format("DD/MM/YYYY");
  };
  getModuleRoleEmployee = (serviceModuleRole, employeeModuleRole) => {
    // Lọc ra JSON module dựa vào module của service và module mà employee được cấp phép
    let moduleRole = serviceModuleRole;
    for (let key in serviceModuleRole) {
      for (let subKey in serviceModuleRole[key]) {
        moduleRole[key][subKey] = 0;
      }
    }
    let keyServiceRole = Object.keys(serviceModuleRole);
    moduleRole = { ...moduleRole, ...employeeModuleRole };
    return _pick(moduleRole, keyServiceRole);
  };
  changeArrBranch = async (arrBranch) => {
    this.setState({
      branch: arrBranch,
    });
  };
  handleStatusButton = () => {
    // is required
  };
  arrHaveBranchName = (branchArr) => {
    let branchCodeArr = [];
    if (Array.isArray(branchArr)) {
      branchArr.map((e) => {
        branchCodeArr.push({
          branchName: this.SelectedBranch.getBranchName(e),
          branchCode: e,
        });
      });
      return branchCodeArr;
    } else return [];
  };
  parseBranchCodeArr = (branch) => {
    if (Array.isArray(branch)) {
      return branch.map((e) => e.branchCode);
    } else return [];
  };
  render() {
    const { classes, t, moduleRole } = this.props;
    const { editEmployee, branch } = this.state;
    return (
      <div className={classes.DialogContent}>
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("employees_listemployee_editemployee_editcontent_cancel")}
          agree={t(this.state.dialog.messageConfirm)}
          title={t("employees_listemployee_editemployee_editcontent_notice")}
          content={t(this.state.dialog.content)}
          action={this.actionDialog}
        />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Loading onRef={(id) => (this.loading = id)} />
        <Grid container spacing={3} className={classes.DialogContent}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFileReader
              onRef={(id) => (this.InputFileReader = id)}
              style={classes}
              defaultImg={editEmployee.avatarImage}
              selectStorageMode={true}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={10}
            lg={10}
            className={classes.containerLeft}
          >
            <Grid container spacing={3}>
              {/* countryCode */}
              <Grid item xs={12} sm={12} md={3}>
                <CountryCode
                  disabled={true}
                  margin="normal"
                  code={editEmployee.countryCode}
                  handleCountryCode={this.handleInputChange}
                />
              </Grid>
              {/* mobile */}
              <Grid item xs={12} sm={12} md={3}>
                <InputFormat
                  disabled
                  label={t(
                    "employees_listemployee_editemployee_editcontent_mobile"
                  )}
                  value={editEmployee.mobile}
                  margin="normal"
                />
              </Grid>
              {/* createdAt */}
              <Grid item xs={12} sm={12} md={3}>
                <InputFormat
                  disabled
                  label={t(
                    "employees_listemployee_editemployee_editcontent_employee_created_at"
                  )}
                  value={this.getFormattedDate(editEmployee.createdAt)}
                  margin="normal"
                />
              </Grid>
              {/* updatedAt */}
              <Grid item xs={12} sm={12} md={3}>
                <InputFormat
                  disabled
                  label={t(
                    "employees_listemployee_editemployee_editcontent_employee_updated_at"
                  )}
                  value={this.getFormattedDate(editEmployee.updatedAt)}
                  margin="normal"
                />
              </Grid>
              {/* name */}
              <Grid item xs={12} sm={12} md={4}>
                <InputFormat
                  required
                  label={t(
                    "employees_listemployee_editemployee_editcontent_name"
                  )}
                  value={editEmployee.name === null ? "" : editEmployee.name}
                  margin="normal"
                  onChange={(event) =>
                    this.handleInputChange("name", event.target.value)
                  }
                />
              </Grid>
              {/* nickname */}
              <Grid item xs={12} sm={12} md={4}>
                <InputFormat
                  label={t(
                    "employees_listemployee_editemployee_editcontent_nickname"
                  )}
                  value={
                    editEmployee.nickname === null ? "" : editEmployee.nickname
                  }
                  margin="normal"
                  onChange={(event) =>
                    this.handleInputChange("nickname", event.target.value)
                  }
                />
              </Grid>
              {/* stt */}
              <Grid item xs={12} sm={12} md={4}>
                <InputFormat
                  label={t(
                    "employees_listemployee_editemployee_editcontent_employee_no"
                  )}
                  value={
                    editEmployee.employeeNumber === null
                      ? ""
                      : editEmployee.employeeNumber
                  }
                  margin="normal"
                  onChange={(event) =>
                    this.handleInputChange("employeeNumber", event.target.value)
                  }
                />
              </Grid>
              {/* type employee */}
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className={classes.TextFieldGroup}
              >
                <InputFormat
                  select
                  label={t("employee_addemployee_type_employee")}
                  margin="normal"
                  value={this.state.editEmployee.typeEmployee}
                  onChange={(event) =>
                    this.handleInputChange("typeEmployee", event.target.value)
                  }
                >
                  {this.typeEmployee.map((type, i) => {
                    return (
                      <MenuItem key={`${type}-${i}`} value={type}>
                        {t("employee_addemployee_" + type)}
                      </MenuItem>
                    );
                  })}
                </InputFormat>
              </Grid>
              {/* bonus */}
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className={classes.TextFieldGroup}
              >
                <InputFormat
                  label={t(
                    "employees_listemployee_editemployee_editcontent_employee_bonus"
                  )}
                  value={editEmployee.bonus}
                  margin="normal"
                  onChange={(event) =>
                    this.handleInputChange("bonus", event.target.value)
                  }
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                      <InputAdornment position="end">
                        {editEmployee.typeBonus === "percent"
                          ? "%"
                          : this.props.currencyCode}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {/* typeBonus */}
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className={classes.TextFieldGroup}
              >
                <InputFormat
                  select
                  label={t(
                    "employees_listemployee_editemployee_editcontent_employee_typeBonus"
                  )}
                  margin="normal"
                  value={editEmployee.typeBonus || "percent"}
                  onChange={(event) =>
                    this.handleInputChange("typeBonus", event.target.value)
                  }
                >
                  {this.listTypeBonus.map((typeBonus, i) => {
                    return (
                      <MenuItem key={`${typeBonus}-${i}`} value={typeBonus}>
                        {typeBonus === "value"
                          ? this.props.currencyCode
                          : t(
                              "employees_listemployee_editemployee_editcontent_" +
                                typeBonus
                            )}
                      </MenuItem>
                    );
                  })}
                </InputFormat>
              </Grid>
              {/* code */}
              <Grid item xs={12} sm={12} md={4}>
                <InputFormat
                  label={t(
                    "employees_listemployee_editemployee_editcontent_employee_code"
                  )}
                  value={editEmployee.code === null ? "" : editEmployee.code}
                  margin="normal"
                  onChange={(event) =>
                    this.handleInputChange("code", event.target.value)
                  }
                />
              </Grid>
              {/* salary */}
              {moduleRole &&
                moduleRole.employeeSystem &&
                !!moduleRole.employeeSystem.viewSalary && (
                  <Grid item xs={12} sm={12} md={4}>
                    <InputFormat
                      label={t(
                        "employees_listemployee_editemployee_editcontent_employee_salary"
                      )}
                      value={
                        editEmployee.salary === null ? "" : editEmployee.salary
                      }
                      margin="normal"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                      onChange={(event) =>
                        this.handleInputChange("salary", event.target.value)
                      }
                    />
                  </Grid>
                )}
              {/* typeSalary */}
              {moduleRole &&
                moduleRole.employeeSystem &&
                !!moduleRole.employeeSystem.viewSalary && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    className={classes.TextFieldGroup}
                  >
                    <InputFormat
                      select
                      label={t(
                        "employees_listemployee_editemployee_editcontent_employee_typeSalary"
                      )}
                      margin="normal"
                      value={
                        editEmployee.typeSalary === null
                          ? ""
                          : editEmployee.typeSalary
                      }
                      onChange={(event) =>
                        this.handleInputChange("typeSalary", event.target.value)
                      }
                    >
                      {this.listTypeSalary.map((typeSalary, i) => {
                        return (
                          <MenuItem
                            key={`${typeSalary.name}-${i}`}
                            value={typeSalary.value}
                          >
                            {t("employees_listemployee_" + typeSalary.name)}
                          </MenuItem>
                        );
                      })}
                    </InputFormat>
                  </Grid>
                )}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.TextFieldGroup}
              >
                <SelectedBranch
                  onRef={(id) => (this.SelectedBranch = id)}
                  multiple={true}
                  required={true}
                  value={branch}
                  handleChangeBranch={(arrBranch) =>
                    this.changeArrBranch(arrBranch)
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            lg={2}
            className={classes.containerSwitchandButton}
          >
            <div className={classes.activeContainer}>
              <FormGroup classes={{ root: classes.formGroupRoot }}>
                <Typography variant="body1" classes={{ body1: classes.body1 }}>
                  {t(
                    "employees_listemployee_editemployee_editcontent_employee_active"
                  )}
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      checked={editEmployee.active === 1 ? true : false}
                      color="secondary"
                      disableRipple
                      onChange={(event) =>
                        this.handleChangeSwitchBar(
                          "active",
                          event.target.checked
                        )
                      }
                    />
                  }
                  classes={{ root: classes.rootSwitchIcon }}
                />
              </FormGroup>
              <div className={classes.GroupButton}>
                <Button
                  className={classes.button}
                  variant="contained"
                  onClick={() => this.handleOpenDialog("delete")}
                >
                  {t("employees_listemployee_editemployee_editcontent_fired")}
                </Button>
                <Button
                  color="primary"
                  className={classes.button}
                  variant="contained"
                  onClick={() => this.handleOpenDialog("update")}
                >
                  {t("employees_listemployee_editemployee_editcontent_save")}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      // </PopUpInterface>
    );
  }
}

const mapState = (state) => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  serviceCode: state.user.user.roleId.serviceCode,
  moduleRole: state.user.module,
});

const mapDispatch = (dispatch) => ({
  employeeDispatch: dispatch.employees,
  uploadDispatch: dispatch.upload,
  findByCode: dispatch.employees.findByCode,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(editStyle, { withTheme: 0 })(EditInfo)));
